<template>
    <div class="panel panel-default m-b-5" v-if="taxes.length > 0">
        <div class="p-10-20">
            <div class="table-responsive">
                <table class="table m-0 table_quote_show">
                    <tbody>
                    <tr v-for="(item, index) in taxes">
                        <td class="t_right" colspan="2">{{ item.description }}</td>
                        <td class="t_right w_150">
                            {{ item.value * record.exchange_rate | pmlCurrency(currency.symbol) }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="t_right t_uppercase bold">{{ `${$t('total')} ${$t('taxes')}` }}</td>
                        <td class="t_right bold w_150">
                            {{ record.total_taxes * record.exchange_rate | pmlCurrency(currency.symbol) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Taxes',
        props: ['record', 'taxes', 'currency']
    }
</script>



// WEBPACK FOOTER //
// src/modules/my-quotation/components/Taxes.vue